import React from "react";
import { Helmet } from "react-helmet"; // ✅ Import Helmet
import "./Contact.css";
import Certificate1 from "./images/certificate1.jpg";
import Certificate2 from "./images/certificate2.jpg";

const Contact = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Get form data
    const form = e.target;
    const name = form.name.value;
    const email = form.email.value;
    const phone = form.phone.value;
    const subject = form.subject.value;
    const message = form.message.value;
    
    // Create WhatsApp message
    const whatsappMessage = `New Contact Form Submission from mketech.in:\n\nName: ${name}\nEmail: ${email}\nPhone: ${phone}\nSubject: ${subject}\nMessage: ${message}`;
    
    // Encode message for WhatsApp URL
    const encodedMessage = encodeURIComponent(whatsappMessage);
    
    // Open WhatsApp with the message
    window.open(`https://wa.me/919155599968?text=${encodedMessage}`, '_blank');
  };

  return (
    <div className="contact-page-container">
      {/* ✅ Helmet SEO Meta Tags */}
      <Helmet>
        <title>Contact MK e-Tech | Get in Touch for IT Solutions & Support</title>
        <meta
          name="description"
          content="Contact MKE Tech for IT services, digital solutions, technical support, careers, and business inquiries. Reach us via email, phone, or WhatsApp."
        />
        <meta
          name="keywords"
          content="MKE Tech contact, IT support, business inquiry, digital solutions, technical support, partnership, careers, sales inquiry, contact form, IT company India, software development, IT services Aurangabad, Pune IT solutions, Bengaluru IT support, Hyderabad IT company, Chennai IT services, New York IT solutions, Sydney IT company, Vietnam IT services"
        />
      </Helmet>

      <div className="contact-grid">
        {/* Contact Information Sidebar */}
        <div className="contact-info-sidebar">
          <h2 className="sidebar-title">Hate Filling out Forms?</h2>

          <div className="contact-section">
            <h3 className="contact-heading">Request a Quote</h3>
            <a href="mailto:digital@justseo.in" className="contact-email">
              info@mketech.in
            </a>
          </div>

          <div className="contact-section">
            <h3 className="contact-heading">Management</h3>
            <a href="mailto:ceo@mketech.co" className="contact-email">
              Email: ceo@mketech.co
            </a>
            <h3 className="contact-heading">HR Queries</h3>
            <a href="mailto:hr@justseo.in" className="contact-email">
              Email: hr@mketech.co
            </a>
            <a href="tel:+919155599968" className="contact-phone">
              Call: +91-9155599968
            </a>
          </div>

          <div className="contact-section">
            <h3 className="contact-heading">Call</h3>
            <a href="tel:+912269710459" className="contact-phone">
              +91-2269710459
            </a>
          </div>

          <div className="contact-section">
            <h3 className="contact-heading">Whatsapp</h3>
            <a href="https://wa.me/+919155599968" className="contact-whatsapp">
              +91-9155599968
            </a>
          </div>
        </div>

        {/* Contact Form */}
        <div className="unique-contact-form-container">
          <h2 className="unique-form-title">Get in Touch</h2>
          <form onSubmit={handleSubmit} className="unique-contact-form">
            <div className="unique-form-group">
              <label htmlFor="name">Your Name</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Enter your name"
                required
              />
            </div>

            <div className="unique-form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter your email"
                required
              />
            </div>

            <div className="unique-form-group">
              <label htmlFor="phone">Phone Number</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                placeholder="Enter your phone number"
              />
            </div>

            <div className="unique-form-group">
              <label htmlFor="subject">Subject</label>
              <select id="subject" name="subject">
                <option value="">Select a subject</option>
                <option value="Sales Inquiry">Sales Inquiry</option>
                <option value="Technical Support">Technical Support</option>
                <option value="Partnership">Partnership</option>
                <option value="Careers">Careers</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="unique-form-group">
              <label htmlFor="message">Your Message</label>
              <textarea
                id="message"
                name="message"
                rows="5"
                placeholder="Enter your message here..."
                required
              ></textarea>
            </div>

            <button type="submit" className="unique-submit-btn">
              Send Message
            </button>
          </form>
        </div>
      </div>
      {/* Global Presence Section */}
      <div className="global-presence">
        <h2 className="global-title">Our Global Presence</h2>

        <div className="location-grid">
          <div className="location-card">
            <div className="card-content">
              <h3 className="location-title">Registered Office</h3>
              <p className="location-address">
                N-9 , A-116, L-104/2 Shiva, Cidco Aurangabad, Maharashtra,
                431001.
              </p>
              <a href="mailto:info@mketech.in" className="location-email">
                <span className="email-icon">✉</span> info@mketech.in
              </a>
            </div>
          </div>

          <div className="location-card">
            <div className="card-content">
              <h3 className="location-title">Corporate Office</h3>
              <p className="location-address">
                B-13, 2nd Floor, Prozone Trade Center, beside Prozone Mall, MIDC
                Industrial Area, Chilkalthana, Aurangabad, Maharashtra 431003
              </p>
              <a href="mailto:info@mketech.in" className="location-email">
                <span className="email-icon">✉</span> info@mketech.in
              </a>
            </div>
          </div>

          <div className="location-card">
            <div className="card-content">
              <h3 className="location-title">Pune</h3>
              <p className="location-address">
                Blue Ridge Township, Phase II, Near Rajiv Gandhi Infotech Park -
                Phase I, Hinjawadi, India, Pune, 411057
              </p>
              <a href="mailto:pune@mketech.co" className="location-email">
                <span className="email-icon">✉</span> pune@mketech.co
              </a>
            </div>
          </div>

          <div className="location-card">
            <div className="card-content">
              <h3 className="location-title">Bengaluru</h3>
              <p className="location-address">
                S End C Cross Rd, KSRTC Layout, 3 nd Phase, JP Nagar, Bengaluru,
                Karnataka 560078
              </p>
              <a href="mailto:help@mketech.co" className="location-email">
                <span className="email-icon">✉</span> help@mketech.co
              </a>
            </div>
          </div>

          <div className="location-card">
            <div className="card-content">
              <h3 className="location-title">Vietnam</h3>
              <p className="location-address">
                29th Floor East Tower 54 Lieu Giai Ba Dinh District, Vietnam
                10149
              </p>
              <a href="mailto:help@mketech.co" className="location-email">
                <span className="email-icon">✉</span> help@mketech.co
              </a>
            </div>
          </div>

          <div className="location-card">
            <div className="card-content">
              <h3 className="location-title">Hyderabad</h3>
              <p className="location-address">
                Admin Block, Mariner Bldg The V Plot No. 17, Software Units
                Layout Madhapur Hyderabad 500081
              </p>
              <a href="mailto:help@mketech.co" className="location-email">
                <span className="email-icon">✉</span> help@mketech.co
              </a>
            </div>
          </div>

          <div className="location-card">
            <div className="card-content">
              <h3 className="location-title">New York</h3>
              <p className="location-address">
                295 Madison Ave 12th Floor New York City, NY 10017
              </p>
              <a href="mailto:help@mketech.co" className="location-email">
                <span className="email-icon">✉</span> help@mketech.co
              </a>
            </div>
          </div>

          <div className="location-card">
            <div className="card-content">
              <h3 className="location-title">Chennai</h3>
              <p className="location-address">
                5 st Floor, Pinnacle Building International Tech Park Chennai
                (ITPC) Taramani Road Chennai-600113
              </p>
              <a href="mailto:help@mketech.co" className="location-email">
                <span className="email-icon">✉</span> help@mketech.co
              </a>
            </div>
          </div>

          <div className="location-card">
            <div className="card-content">
              <h3 className="location-title">Sydney</h3>
              <p className="location-address">
                680 George Street Level 45, Haymarket Sydney, Australia 2000
              </p>
              <a href="mailto:help@mketech.co" className="location-email">
                <span className="email-icon">✉</span> help@mketech.co
              </a>
            </div>
          </div>
        </div>

        <div className="iso-certification-container">
          <div className="iso-card">
            <div className="iso-badge">ISO</div>
            <div className="iso-content">
              <h3 className="iso-title">ISO Certified Certification</h3>
              <div className="iso-divider"></div>
              <div className="certificate-img">
                <img src={Certificate1} alt="img"></img>
              </div>
              <p className="iso-company">QUALITY MANAGEMENT SYSTEM</p>
              <p className="iso-number">ISO 9001:2015 (QMS)</p>
            </div>
          </div>

          <div className="iso-card">
            <div className="iso-badge">ISO</div>
            <div className="iso-content">
              <h3 className="iso-title">ISO Certified Certification</h3>
              <div className="iso-divider"></div>

              {/* <p className="iso-standard">QUALITY MANAGEMENT SYSTEM</p> */}
              <div className="certificate-img">
                <img src={Certificate2} alt="img"></img>
              </div>
              <p className="iso-company">Certificate of Compliance</p>
              <p className="iso-number">ISO 27001:2022 </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
